import {
  clicksFormat,
  impsFormat,
  revenueBuyingCurrencyFormat,
  ctrFormat,
  cpcFormat,
  cpmFormat,
} from '@/middlewares/numberFormat'

class ChartUtils {
  static makeChartOptions({ chartSelectedArray, chartData }) {
    const res = this.chartSelectedArrayToChartOptions(chartSelectedArray)
    const noAxesYs = {
      size: { height: 160 },
      data: {
        // fetch したデータのアサイン
        json: chartData,
        keys: {
          x: 'reportDate',
          value: res.data.keys.value,
        },
        axes: res.data.axes,
        // types: o.types,
        xFormat: '%Y-%m-%d',
        colors: res.data.colors,
      },
      axis: {
        x: {
          type: 'timeseries',
          tick: {
            format: '%Y-%m-%d',
          },
        },
      },
      tooltip: {
        // 各点にマウスオーバーした際に出てくる部分の設定
        format: {
          name: function(name, _, id) {
            switch (id) {
              case 'revenueBuyingCurrency':
                return '消化金額'
              case 'imps':
                return 'インプレッション'
              case 'clicks':
                return 'クリック'
              case 'ctr':
                return 'CTR'
              case 'cpc':
                return 'CPC'
              case 'cpm':
                return 'CPM'
              default:
                return name
            }
          },
          value(value, _, id) {
            switch (id) {
              case 'revenueBuyingCurrency':
                return revenueBuyingCurrencyFormat(value)
              case 'imps':
                return impsFormat(value)
              case 'clicks':
                return clicksFormat(value)
              case 'ctr':
                return ctrFormat(value)
              case 'cpc':
                return cpcFormat(value)
              case 'cpm':
                return cpmFormat(value)
              default:
                return value
            }
          },
        },
      },
      grid: {
        x: {
          show: false,
        },
        y: {
          show: false,
        },
      },
      legend: {
        show: false,
        position: 'bottom',
      },
    }

    const { axes } = res
    for (const prop in axes) {
      const name = axes[prop].name
      const formatter = this.yAxesFormatSelector(name)
      noAxesYs.axis[prop] = {
        label: {
          text: axes[prop].label.text,
          position: 'outer-middle',
        },
        show: true,
        min: 0,
        padding: {
          bottom: 0,
        },
        tick: {
          format: formatter,
        },
      }
    }
    return noAxesYs
  }

  static makeChartSelectedArray(selectedLeft, selectedRight) {
    const leftObject = this.nameSelectedToObject(selectedLeft)
    const rightObject = this.nameSelectedToObject(selectedRight)

    // 関数型に書けないコーダーの敗北
    const array = []

    if (leftObject) {
      leftObject.axis = 'y'
      array.push(leftObject)
    }

    if (rightObject) {
      rightObject.axis = 'y2'
      array.push(rightObject)
    }

    return array
  }

  static nameSelectedToObject(name) {
    switch (name) {
      case 'revenueBuyingCurrency':
        return {
          name: 'revenueBuyingCurrency',
          unit: '消化金額',
          color: '#0200ff',
        }

      case 'imps':
        return {
          name: 'imps',
          unit: 'インプレッション / 回',
          color: '#17b106',
        }

      case 'clicks':
        return {
          name: 'clicks',
          unit: 'クリック / 回',
          color: '#ff3140',
        }

      case 'ctr':
        return {
          name: 'ctr',
          unit: 'CTR',
          color: '#487cff',
        }

      case 'cpc':
        return {
          name: 'cpc',
          unit: 'CPC',
          color: '#ff6a14',
        }

      case 'cpm':
        return {
          name: 'cpm',
          unit: 'CPM',
          color: '#1fe008',
        }

      default:
    }
  }

  static chartSelectedArrayToChartOptions(array) {
    return {
      data: {
        keys: {
          value: this.chartSelectedArrayToDataKeysValue(array),
        },
        axes: this.chartSelectedArrayToDataAxes(array),
        colors: this.chartSelectedArrayToDataColors(array),
      },
      axes: this.chartSelectedArrayToAxes(array),
    }
  }

  static chartSelectedArrayToDataKeysValue(array) {
    return array.map(o => o.name)
  }

  static chartSelectedArrayToDataAxes(array) {
    return array.reduce((result, item) => {
      result[item.name] = item.axis
      return result
    }, {})
  }

  static chartSelectedArrayToDataColors(array) {
    return array.reduce((result, item) => {
      result[item.name] = item.color
      return result
    }, {})
  }

  static chartSelectedArrayToAxes(array) {
    return array.reduce((result, item) => {
      result[item.axis] = {
        label: {
          text: item.unit,
        },
        name: item.name,
      }
      return result
    }, {})
  }

  static yAxesFormatSelector(name) {
    switch (name) {
      case 'revenueBuyingCurrency':
        return d => revenueBuyingCurrencyFormat(d)
      case 'imps':
        return d => impsFormat(d)
      case 'clicks':
        return d => clicksFormat(d)
      case 'ctr':
        return d => ctrFormat(d)
      case 'cpc':
        return d => cpcFormat(d)
      default:
        return d => d
    }
  }
}

export default ChartUtils
